var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2261_1505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.882 73.1191L246.882 57.1191L204.482 15.0391L188.482 31.0391L174.562 45.1191L158.562 61.1191L125.442 94.2391C109.016 82.8848 88.9369 78.0841 69.1512 80.7804C49.3655 83.4766 31.3035 93.4748 18.5143 108.81C5.72513 124.146 -0.866496 143.71 0.0347026 163.658C0.935901 183.606 9.26476 202.496 23.3846 216.616C37.5045 230.736 56.3945 239.065 76.3427 239.966C96.2909 240.867 115.855 234.276 131.191 221.487C146.526 208.697 156.524 190.635 159.221 170.85C161.917 151.064 157.116 130.985 145.762 114.559L179.202 81.1191L200.962 103.039L216.962 87.0391L195.042 65.2791L209.122 51.3591L230.882 73.1191ZM80.0019 217.599C68.6097 217.599 57.4733 214.221 48.001 207.892C38.5287 201.563 31.146 192.567 26.7864 182.042C22.4268 171.517 21.2861 159.935 23.5086 148.762C25.7311 137.589 31.217 127.325 39.2725 119.27C47.328 111.214 57.5914 105.728 68.7647 103.506C79.938 101.283 91.5194 102.424 102.044 106.784C112.569 111.143 121.565 118.526 127.895 127.998C134.224 137.47 137.602 148.607 137.602 159.999C137.602 175.276 131.533 189.926 120.731 200.728C109.929 211.531 95.2783 217.599 80.0019 217.599Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2261_1505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.601726855721aa2631631d077f605717.svg";
export { ForwardRef as ReactComponent };